export default __webpack_public_path__ + "static/PDS_EzyMedical (EV)-11719d228a821f69d361cfc45cd88216.pdf";